import { LanguageCode, SUPPORTED_LANGUAGES } from "../utils/languageRouting";

export const FALLBACK_COUNTRY_INITIAL = "US";

export const LANGUAGE_TO_COUNTRY_INITIAL: Record<LanguageCode, string> = {
  en: "US",
  it: "IT",
  es: "ES",
  fr: "FR",
  de: "DE",
  pt: "PT",
  ru: "RU",
  zh: "CN",
  ja: "JP",
  ar: "AE",
  hi: "IN",
  ko: "KR",
  nl: "NL",
  cs: "CZ",
};

export const isSupportedLanguage = (language: string): language is LanguageCode => {
  return SUPPORTED_LANGUAGES.includes(language as LanguageCode);
};


